module.exports = __webpack_public_path__ + "b0341639242fd826587109d381c4d0a1.svg";